import { useFlags } from 'launchdarkly-react-client-sdk';
import { ComponentProps, FC } from 'react';

import { PROMO_4 } from 'src/constants';
import { MICROCOPY } from 'src/data/microcopy/microcopyDictionary';
import { PromoPillBanner } from 'src/general/components/PromoPillBanner/PromoPillBanner';
import { processKilometers } from 'src/general/helpers/processProductApiData';
import { getMicrocopy } from 'src/stores/microcopyStore';
import { ProductDetailsPayload } from 'src/types/ProductDetail.type';

import classNames from 'classnames';
import { hasManufacturerWarranty } from 'src/pdp/helpers/manufacturerWarranty.helper';
import { Car360V1 } from '../Car360V1/Car360V1';
import { WarrantyInfo } from '../WarrantyInfo/WarrantyInfo';
import styles from './CarOverview.module.scss';

const formatWarrantyInfo = (productDetails: ProductDetailsPayload): ComponentProps<typeof WarrantyInfo> => {
  const showWarranty = hasManufacturerWarranty(productDetails);

  const showEligible = showEligibleInfo(productDetails.kilometres);

  return {
    productDetails,
    showWarranty,
    showEligible,
  };
};

const ELIGIBLE_KILOMETRES = 160000;

const showEligibleInfo = (kilometers: string) => {
  const carKilometers = processKilometers(kilometers);
  return carKilometers < ELIGIBLE_KILOMETRES;
};

export const CarOverview: FC<ProductDetailsPayload> = (productDetailsPayload) => {
  const flags = useFlags();
  const title = getMicrocopy(MICROCOPY.PDP_CAR_OVERVIEW_TITLE);
  const warrantyProps = formatWarrantyInfo(productDetailsPayload);
  const showBadges = flags?.uiBadgesEnabled && productDetailsPayload.badges && productDetailsPayload.badges.length > 0;

  if (!showBadges && !warrantyProps.showWarranty && !warrantyProps.showEligible) {
    return null;
  }

  return (
    <section className={styles.root}>
      {showBadges && (
        <>
          <h3 className={classNames(styles.header, 'c-fw-bold', 'c-fs-h5')}>{title}</h3>
          <Car360V1 items={productDetailsPayload.badges} />
        </>
      )}
      {(warrantyProps.showWarranty || warrantyProps.showEligible) && <WarrantyInfo {...warrantyProps} />}
      {productDetailsPayload.search_keywords.includes(PROMO_4) && <PromoPillBanner />}
    </section>
  );
};
